<template>
    <div>

        <a @click="open = true" class="cursor-pointer text-grey-dark hover:text-blue-dark px-4 py-2">
            <i class="fa fa-pencil mr-4"></i> Change colors
        </a>

        <portal to="modals" v-if="open">
            <modal @close="abort()">

                <template slot="header">Change colors</template>

                <!--<template slot="save">-->
                    <div class="mt-4 w-full flex justify-end">
                        <a class="px-4 py-2 text-red-light" @click="abort()">cancel</a>
                        <a class="px-4 py-2 text-white rounded bg-blue-dark" @click="close()">save</a>
                    </div>
                <!--</template>-->

                <h2>Time series colors</h2>

                <ol class="list-decimal">
                    <li class="p-2 flex items-baseline" v-for="(color, index) in colors" :key="index">
                        <label :for="'color-' + index" class="mr-2 cursor-pointer">
                            <i class="fa fa-square" :style="'color: ' + color"></i>
                        </label>
                        <input :id="'color-' + index" class="hidden" type="color" v-model="colors[index]">
                        <input type="text" v-model="colors[index]" class="p-2 border-blue-dark border rounded">
                    </li>
                </ol>


                <div v-show="schemes.length > 0">
                    <h2>Color Schemes</h2>

                    <ul class="list-reset">
                        <li v-for="scheme in schemes" class="mt-2">
                            <a @click="updateScheme(scheme)" class="p-2 block cursor-pointer border hover:border-blue-dark">
                                {{ scheme.name }}
                                <div class="flex p-2" ><!-- :style="'background-color:' + scheme.background_color" -->
                                    <div v-for="color in scheme.colors" class="mr-2">
                                        <i class="fa fa-square" :style="'color: ' + color"></i>
                                    </div>
                                </div>

                            </a>
                        </li>
                    </ul>
                </div>

            </modal>
        </portal>

    </div>
</template>

<script>
    export default {

        data: () => ({
            open: false,
            colors: [],
            backup: [],
            schemes: [],
            backgroundColor: '#fff',
            textColor: '#2d2d2d',
        }),

        name: "Colors",

        watch: {
            open(isOpen) {
                if (isOpen) {
                    this.backgroundColor = this.$store.state.backgroundColor;
                    this.colors = this.$store.state.colors;
                    this.backup = _.cloneDeep(this.$store.state.colors);
                    this.load();
                }
            }
        },

        methods: {
            load() {
                let that = this;
                http.get('/color-schemes').then(function (response) {
                    that.schemes = response.data.color_schemes;
                })
            },
            setColors(colors, store = true) {
                this.$store.dispatch('setColors', {
                    colors: colors,
                    store: store,
                    backgroundColor: this.backgroundColor,
                    textColor: this.textColor,
                });
            },
            close() {
                this.setColors(this.colors, true);
                this.open = false;
            },
            updateScheme(scheme) {
                this.colors = _.cloneDeep(scheme.colors);
                this.backgroundColor = scheme.background_color;
                this.textColor = scheme.textColor;
                this.setColors(this.colors, false);
            },
            abort() {
                this.setColors(this.backup, false);
                this.open = false;
            }
        }
    }
</script>

<style scoped>

</style>
